//import * as moment from "moment";

//import { date } from "@rxweb/reactive-form-validators";
import { TransactionEntryComponent } from "../../bankportal/components/TransactionEntry/transaction-entry.component";

export class BankPortalModel {
    public bankname: string = "";
    public BankPortalDepReqVM: Array<BankPortalDepReqModel> = new Array<BankPortalDepReqModel>();

}
export class BankPortalDepReqModel {
  //  public DeploymentRequestId: string;
    public Merchant: string = "";
    public IdMerchant: string = "";
    public IdTerminal: string = "";
    public Address: string = "";
    public ContactPerson: string = "";
    public RequestedDate: string = "";
    public Province: string = "";
    public MerchantCategory: string = "";
    public TipAdjustment: boolean = false;
    public Refund: boolean = false;
    public ManualTransaction: boolean = false;
    public PinChange! : boolean;
    public CashAdvance! : boolean;
    public District: string = "";
    public Currency: string = "";
    public Priority!:boolean;
    public PreAuthorization: boolean = false;
    public TransactionPrimaryId!: string;
    public TransactionSecondaryId!: string;
    public SettlementSecondaryId!: string;
    public SettlementPrimaryId!: string;
    public MerchantCategoryId!: string;
    public ContactNo1!: string;
    public ContactNo2!: string;
    public InventoryId!: string|null;
    public Component1! :string;
    public Component2!:string;
    public CombineValue! : string;
    public FinalValue! :string;
    public Kvc1! :string;
    public Kvc2! : string;
    public MCC!:string;
    public BranchName! :string;
    public PanNumber! : string;
    public EmailAddress! :string;
    public BankRemarks!: string;
    public TerminalType! :string;
    public BusinessNature! :string;




}

export class DashboardModel{
  public maintenanceNumber! : number;
  public totalDeploy! : number;
  public previousMonth!:  number;
  public currentMonth!: number;
  public pendingDeployment! : number;
  public pendingRemoval!: number;
  public gem!: number;
  public em!: number;
  public iwl!: number;
  public mem!: number;
  public pendingSupport! : number;
  public mgemTwog!: number;
  // public MGEMTWOG: number;
  public mgemThreeg!: number;
  // public MGEMTHREEG: number;
  public miwlTwog!: number;
  // public MIWLTWOG: number;
  public miwlThreeg!:number;
  // public MIWLTHREEG:number;
  public miwlThreegwifi!:number;
  // public MIWLTHREEGWIFI:number;
  public merchantCategoryName!:number;
  public merchantCategoryCount!:number;
  public  provinceName! :string;
  public provinceCount!:number;
  public districtName!:string;
  public districtCount!: number;
  public supportCount!:number;

}
export class BankInfo {
  public Id!: string;
  public bankName!: string;
  public bankCode!: string;
  public contactNo1!: string;
  public address!: string;
  public status!: string;
  public contactPerson1!: string;
  public contactPerson2!: string;
  public contactNo2!: string;
  public logo!: string;
}

export class SupportRequest {
  //  public DeploymentRequestId: string;
    public MerchantName: string = "";
    public MerchantId: string = "";
    public TerminalId: string = "";
    public TerminalType: string = "";
    public SerialKey: string = "";
    public Connectivity: string = "";
    public ContactPerson: string = "";
    public ContactNo: string = "";
    public Issue: string = "";
    public Remarks: string = "";
    //public BankPortalDepReqVM: Array<BankPortalDepReqModel> = new Array<BankPortalDepReqModel>();
    public BankPortalDepReqVM: Array<SupportRequest> = new Array<SupportRequest>();

}

export class  TransactionEntry{

  public SettlementDate :string = "";
  public TrxDate: string = "";
  public MerchantNumber: string = "";
  public TerminalNumber: string = "";

  public CardMask: string = "";

  public RRN: string = "";
  public CardType: string = "";
  public Network: string = "";
  public MerchantName: string = "";
  public MerchantAccount: string = "";
  public TrxAmount: string = "";
  public MSCRate: string = "";
  public MSCAmount: string = "";
  public SettlementAmount: string = "";
  public BankPortalDepReqVM: Array<TransactionEntry> = new Array<TransactionEntry>();


}

